import { useState } from 'react'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from '../../common/util' 

export default function usePutClubStatus() {
    const baseUrl = api.base_url
    const [cookies] = useCookies([ACCESS_TOKEN])
    const [clubStatusError, setClubStatusError] = useState('')

    const putClubStatus = async (clubId: string) => {
        try {
            const response = await axios(`${baseUrl}/academy/active/${clubId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`
                }
            })
        } catch (err) {
            console.error((err as Error).message)
            setClubStatusError((err as Error).message)
        }
    }
    
    return { putClubStatus, clubStatusError }
}